var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaypalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.962 18.494c-.219 1.2-1.087 6.794-1.344 8.375c-.019.113-.063.156-.188.156H4.768a.759.759 0 0 1-.756-.869L7.675 2.912a1.27 1.27 0 0 1 1.25-1.056c9.519 0 10.319-.231 12.75.713c3.756 1.456 4.1 4.969 2.75 8.769c-1.344 3.913-4.531 5.594-8.756 5.644c-2.712.044-4.344-.438-4.706 1.512zM26.319 9.5c-.113-.081-.156-.113-.188.081a14.687 14.687 0 0 1-.55 2.1c-2.494 7.113-9.406 6.494-12.781 6.494c-.381 0-.631.206-.681.587c-1.412 8.775-1.694 10.606-1.694 10.606c-.063.444.219.806.662.806h3.969c.538 0 .981-.394 1.088-.931c.044-.337-.069.381.9-5.706c.288-1.375.894-1.231 1.831-1.231c4.438 0 7.9-1.8 8.931-7.019c.406-2.175.288-4.463-1.487-5.788z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalIcon);
export default __webpack_public_path__ + "static/media/paypal-icon.c076b27683f025a75d33c48b39fb1e40.svg";
export { ForwardRef as ReactComponent };